import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-ticket-overview',
  templateUrl: './ticket-overview.component.html',
  styleUrls: ['./ticket-overview.component.scss']
})
export class TicketOverviewComponent implements OnInit {

  @Input() overviewItems: any;
  @Input() description: any;

  @Output() goTo = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  computeNames(group) {
    return group.toolNames;
  }

  goToClicked(group: any) {
    this.goTo.emit(group.maintenancePlanId);
  }
}
